import $http from '@/api';

const getPersonalDictionary = () => $http.get('/api/staff/personalDictionary')
  .catch((thrown) => {
    console.warn('Personal dictionary exception', thrown);
    return null;
  });

const updatePersonalDictionary = words => $http.patch('/api/staff/personalDictionary', { words })
  .catch((thrown) => {
    console.warn('Personal dictionary exception', thrown);
    return null;
  });

export default {
  getPersonalDictionary,
  updatePersonalDictionary,
};
